import { CommonModule } from '@angular/common';
import { afterNextRender, ChangeDetectorRef, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { PresentmentHeader, ReconciliationApi } from '../../core/reconciliation-api';
import { SpringPage } from '../../core/sftp-api';
import { dateTime, moneyFromCents, text } from '../../shared/formatters';
import { PageNavigation } from '../../shared/page-navigation/page-navigation';

@Component({ selector: 'app-gp-presentments', imports: [CommonModule, FormsModule, PageNavigation], templateUrl: './gp-presentments.html' })
export class GpPresentments {
  readonly pageSizes = [10, 25, 50, 100];
  readonly detailPageSizes = [25, 50, 100];
  readonly text = text;
  readonly dateTime = dateTime;
  readonly moneyFromCents = moneyFromCents;
  headers: PresentmentHeader[] = [];
  dateFrom = '';
  dateTo = '';
  page = 0;
  size = 10;
  total = 0;
  totalPages = 1;
  loading = false;
  error = '';

  constructor(private readonly api: ReconciliationApi, private readonly cdr: ChangeDetectorRef, private readonly router: Router) {
    afterNextRender(() => this.loadHeaders());
  }

  loadHeaders(): void {
    this.loading = true; this.error = '';
    this.api.getPresentmentHeaders(this.page, this.size, this.dateFrom, this.dateTo)
      .pipe(finalize(() => { this.loading = false; this.cdr.markForCheck(); }))
      .subscribe({
        next: (result: SpringPage<PresentmentHeader>) => {
          this.headers = result.content ?? []; this.total = result.totalElements ?? 0; this.totalPages = Math.max(1, result.totalPages ?? 1); this.cdr.markForCheck();
        },
        error: error => { this.error = error?.error?.message ?? 'No se pudieron cargar las presentaciones.'; this.cdr.markForCheck(); }
      });
  }

  openDetail(header: PresentmentHeader): void {
    void this.router.navigate(['/gp-conciliacion/liquidaciones/presentaciones', header.id]);
  }

  applyFilters(): void { this.page = 0; this.loadHeaders(); }
  clearFilters(): void { this.dateFrom = ''; this.dateTo = ''; this.applyFilters(); }
  previous(): void { if (this.page > 0 && !this.loading) { this.page--; this.loadHeaders(); } }
  next(): void { if (this.page + 1 < this.totalPages && !this.loading) { this.page++; this.loadHeaders(); } }
}
